import { type Crossing } from '@trippath/shared';
import { useTranslation } from 'react-i18next';

import { dayRange } from '../../lib/countryFacts';
import { dayShort } from '../../lib/format';

/** A border's task: an arrival form or a travel authorisation is filled, a visa applied for. */
export const isForm = (crossing: Crossing) =>
  crossing.rule?.kind === 'card' || crossing.rule?.kind === 'eta';
export const isVisa = (crossing: Crossing) =>
  crossing.rule?.kind === 'evisa' || crossing.rule?.kind === 'visa';

/** What a border asks to be done, as a tag: filled, to fill in its window, or to apply for by its day. */
export function CrossingTask({ crossing }: { crossing: Crossing }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const due = crossing.due;
  if (due === null) return null;
  if (crossing.done) {
    return <span className="state-tag state-tag-ok">✓ {t('countries.done')}</span>;
  }
  return isVisa(crossing) ? (
    <span className="state-tag state-tag-alert">
      {t('countries.apply', { day: dayShort(due, lang) })}
    </span>
  ) : (
    <span className="state-tag state-tag-warn">
      {t('countries.fill', { range: dayRange(due, crossing.border, lang) })}
    </span>
  );
}
